import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { safeGet, safeSet, safeRemove, safeJsonParse, getSafeSession } from '../utils/browserSafe';
import baseURL from '../url';
import './Cart.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moneda from '../moneda';
import { fetchGeoInfo, getGeoCountryParam, productWithDisplayPrice, filterProductByVisibility } from '../Geo/geoPricing';
import { COUNTRY_PREFIXES, normalizePhone, splitPhone } from '../utils/countryPrefixes';

const DEFAULT_SHIPPING_ZONES = [];

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const [nombreCompleto, setNombreCompleto] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [telefonoPrefix, setTelefonoPrefix] = useState('+53');
    const [detalles, setDetalles] = useState('');
    const [contactos, setContactos] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [provincia, setProvincia] = useState('La Habana');
    const [municipio, setMunicipio] = useState('');
    const [shippingCost, setShippingCost] = useState(0);
    const [buyerNombre, setBuyerNombre] = useState('');
    const [buyerTelefono, setBuyerTelefono] = useState('');
    const [buyerTelefonoPrefix, setBuyerTelefonoPrefix] = useState('+1');
    const [buyerEmail, setBuyerEmail] = useState('');
    const [checkoutStep, setCheckoutStep] = useState('buyer');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [deliveryTime, setDeliveryTime] = useState('');
    const [upsellProducts, setUpsellProducts] = useState([]);
    const [customer, setCustomer] = useState(null);
    const [showAccountChoice, setShowAccountChoice] = useState(false);
    const [geoInfo, setGeoInfo] = useState(null);
    const [shippingZones, setShippingZones] = useState([]);
    const [pendingWhatsappUrl, setPendingWhatsappUrl] = useState('');
    const [pendingWhatsappMessage, setPendingWhatsappMessage] = useState('');
    const [showWhatsappConfirm, setShowWhatsappConfirm] = useState(false);

    useEffect(() => {
        cargarContacto();
        cargarShippingZones();
        fetchGeoInfo().then((info) => {
            setGeoInfo(info);
            if (info && !info.isCuba) { setPaymentMethod('zelle'); setBuyerTelefonoPrefix('+1'); setTelefonoPrefix('+53'); }
            else { setPaymentMethod('efectivo'); setTelefonoPrefix('+53'); }
            cargarProductos(info);
        });
        cargarCliente();
    }, []);

    useEffect(() => {
        hydrateCartFromStorage();
    }, [productos, isFocused]);

    useEffect(() => {
        const subtotal = cartItems.reduce((acc, item) => acc + ((Number(item?.precio) || 0) * (Number(item?.cantidad) || 0)), 0);
        setTotalPrice(subtotal);
    }, [cartItems]);

    useEffect(() => {
        const handleCartUpdated = () => hydrateCartFromStorage();
        window.addEventListener('cartUpdated', handleCartUpdated);
        return () => window.removeEventListener('cartUpdated', handleCartUpdated);
    }, [productos]);

    useEffect(() => {
        const handleCustomerUpdated = (event) => {
            setCustomer(event.detail || null);
        };
        window.addEventListener('ky13CustomerUpdated', handleCustomerUpdated);
        return () => window.removeEventListener('ky13CustomerUpdated', handleCustomerUpdated);
    }, []);

const cargarShippingZones = () => {
    fetch(`${baseURL}/shippingZonesGet.php`, { method: 'GET' })
        .then(response => response.json())
        .then(data => {
            if (data?.ok && Array.isArray(data.zones)) setShippingZones(data.zones);
        })
        .catch(error => console.error('Error al cargar zonas:', error));
};

const getZonePrice = (zone) => {
    if (!zone) return 0;
    const isCuba = geoInfo?.isCuba;
    return Number(isCuba ? zone.precioMn : zone.precioUsd) || 0;
};

const provinciasDisponibles = [...new Set((shippingZones.length ? shippingZones : DEFAULT_SHIPPING_ZONES).map(z => z.provincia))];
const municipiosDisponibles = (shippingZones.length ? shippingZones : DEFAULT_SHIPPING_ZONES).filter(z => z.provincia === provincia);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto?.reverse?.()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = (geo = geoInfo) => {
        const countryParam = geo?.countryCode ? `?country=${encodeURIComponent(geo.countryCode)}` : getGeoCountryParam();
        fetch(`${baseURL}/productosGet.php${countryParam}`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const list = (data.productos || [])
                    .filter(item => filterProductByVisibility(item, geo))
                    .map(item => productWithDisplayPrice(item, geo));
                setProductos(list);
                setUpsellProducts(list.filter(p => Number(p.activo ?? 1) === 1).sort((a,b)=>Number(b.salesCount||0)-Number(a.salesCount||0)).slice(0,4));
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const hydrateCartFromStorage = () => {
        const cart = safeJsonParse(safeGet('cart','[]'), []);
        const items = cart.map((cartItem) => {
            const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
            return producto ? {
                ...producto,
                cantidad: cartItem.cantidad,
                item: cartItem.item,
            } : null;
        }).filter(Boolean);

        setCartItems(items);
        setLoading(false);
    };


    const cargarCliente = () => {
        fetch(`${baseURL}/cliente_me.php`, { credentials: 'include' })
            .then(response => response.json())
            .then(data => {
                if (data?.ok && data.cliente) {
                    setCustomer(data.cliente);
                    safeSet('ky13_customer_profile', JSON.stringify(data.cliente));
                } else {
                    const local = safeGet('ky13_customer_profile');
                    if (local) {
                        try { setCustomer(JSON.parse(local)); } catch (e) {}
                    }
                }
            })
            .catch(() => {
                const local = safeGet('ky13_customer_profile');
                if (local) {
                    try { setCustomer(JSON.parse(local)); } catch (e) {}
                }
            });
    };

    const fillCheckoutWithCustomer = () => {
        if (!customer) return;
        const parsed = splitPhone(customer.telefono || '', (geoInfo && !geoInfo.isCuba) ? '+1' : '+53');
        if (geoInfo && !geoInfo.isCuba) {
            setBuyerNombre(customer.nombreCompleto || '');
            setBuyerTelefonoPrefix(parsed.prefix);
            setBuyerTelefono(parsed.phone);
            setBuyerEmail(customer.email || '');
        } else {
            setNombreCompleto(customer.nombreCompleto || '');
            setDireccion(customer.direccion || '');
            setTelefonoPrefix(parsed.prefix);
            setTelefono(parsed.phone);
        }
    };

    const useAccountData = () => {
        fillCheckoutWithCustomer();
        setShowAccountChoice(false);
        if (geoInfo && !geoInfo.isCuba) setCheckoutStep('receiver');
    };

    const skipAccountData = () => {
        setShowAccountChoice(false);
    };

    const obtenerImagen = (item) => {
        return item?.imagen1 || item?.imagen2 || item?.imagen3 || item?.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
        setCheckoutStep((geoInfo && !geoInfo.isCuba) ? 'buyer' : 'receiver');
        setShowAccountChoice(Boolean(customer));
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const syncCart = (updatedCartItems) => {
        setCartItems(updatedCartItems);
        safeSet('cart', JSON.stringify(updatedCartItems));
        if (typeof window !== 'undefined') window.dispatchEvent(new Event('cartUpdated'));
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        syncCart(updatedCart);
    };

    const clearCart = () => {
        setCartItems([]);
        safeRemove('cart');
        if (typeof window !== 'undefined') window.dispatchEvent(new Event('cartUpdated'));
    };

    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        syncCart(updatedCartItems);
    };

    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            syncCart(updatedCartItems);
        }
    };

    const handleMunicipioChange = (value) => {
        setMunicipio(value);
        const zone = (shippingZones.length ? shippingZones : DEFAULT_SHIPPING_ZONES).find(z => z.provincia === provincia && z.municipio === value);
        setShippingCost(getZonePrice(zone));
    };

    const handleProvinciaChange = (value) => {
        setProvincia(value);
        setMunicipio('');
        setShippingCost(0);
        setBuyerNombre('');
        setBuyerTelefono('');
        setBuyerEmail('');
        setCheckoutStep('buyer');
        setDeliveryDate('');
        setDeliveryTime('');
    };

    const totalFinal = totalPrice + (deliveryOption === 'delivery' ? shippingCost : 0);

    const formatMoney = (value) => `${moneda} ${Number(value || 0).toFixed(2)}`;

    const resetForm = () => {
        setNombreCompleto('');
        setDireccion('');
        setTelefono('');
        setTelefonoPrefix('+53');
        setBuyerTelefono('');
        setBuyerTelefonoPrefix('+1');
        setDetalles('');
        setPaymentMethod('efectivo');
        setDeliveryOption('delivery');
        setProvincia('La Habana');
        setMunicipio('');
        setShippingCost(0);
    };


    const isIOSDevice = () => {
        if (typeof navigator === 'undefined') return false;
        return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };

    const openWhatsappNow = (url) => {
        window.location.href = url;
    };

    const handleWhatsappMessage = async () => {
        const isExternalOrder = Boolean(geoInfo && !geoInfo.isCuba);
        if (isExternalOrder && (!buyerNombre.trim() || !buyerTelefono.trim() || !buyerEmail.trim())) {
            toast.error('Completa los datos de la persona que compra', { autoClose: 1400 });
            setCheckoutStep('buyer');
            return;
        }
        if (!telefono.trim()) {
            toast.error('Debes escribir el teléfono del cliente', { autoClose: 1200 });
            return;
        }

        if (deliveryOption === 'delivery') {
            if (!provincia) {
                toast.error('Selecciona la provincia', { autoClose: 1200 });
                return;
            }
            if (!municipio) {
                toast.error('Selecciona el municipio', { autoClose: 1200 });
                return;
            }
            if (!direccion.trim()) {
                toast.error('Debes escribir la dirección', { autoClose: 1200 });
                return;
            }
        }

        const fullReceiverPhone = normalizePhone(telefonoPrefix, telefono);
        const fullBuyerPhone = normalizePhone(buyerTelefonoPrefix, buyerTelefono);
        const phoneNumber = `${contactos.telefono || ''}`;

        const productosPedido = cartItems.map((item) => ({
            idProducto: item.idProducto,
            titulo: item.titulo,
            cantidad: item.cantidad,
            item: item.item || [],
            variante: item.variante || (item.item && item.item[0]) || '',
            precio: item.precio,
            precioMn: item.precioMn || 0,
            precioUsd: item.precioUsd || 0,
            imagen: obtenerImagen(item)
        }));

        let facturaNumero = '';

        try {
            const formData = new FormData();
            formData.append('idMesa', '');
            formData.append('estado', 'Pendiente');
            formData.append('estadoPedido', 'pendiente');
            formData.append('productos', JSON.stringify(productosPedido));
            formData.append('carritoJson', JSON.stringify(productosPedido));
            formData.append('subtotal', totalPrice.toFixed(2));
            formData.append('costoEnvio', deliveryOption === 'delivery' ? shippingCost.toFixed(2) : '0.00');
            formData.append('total', totalFinal.toFixed(2));
            formData.append('nombre', nombreCompleto);
            formData.append('nombreCompleto', nombreCompleto);
            formData.append('telefono', fullReceiverPhone);
            formData.append('direccion', direccion);
            formData.append('detalles', detalles);
            formData.append('nota', detalles);
            formData.append('formaPago', paymentMethod === 'zelle' ? 'Zelle' : 'Efectivo');
            formData.append('tipoEntrega', deliveryOption === 'delivery' ? 'Envío a domicilio' : 'Recogida en el local');
            formData.append('provincia', provincia);
            formData.append('municipio', municipio);
            formData.append('codigo', '');
            if (customer?.idCliente) formData.append('idCliente', customer.idCliente);
            formData.append('isExternalOrder', (geoInfo && !geoInfo.isCuba) ? '1' : '0');
            formData.append('buyerNombre', buyerNombre);
            formData.append('buyerTelefono', fullBuyerPhone);
            formData.append('buyerEmail', buyerEmail);
            formData.append('deliveryDate', deliveryDate);
            formData.append('deliveryTime', deliveryTime);

            const saveResponse = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData
            });
            const saveData = await saveResponse.json();
            if (saveData?.facturaNumero) {
                facturaNumero = saveData.facturaNumero;
            }
        } catch (error) {
            console.error('Error al guardar pedido antes de WhatsApp:', error);
        }

        const productosTexto = cartItems.map((item) => {
            const cantidad = Number(item?.cantidad || 0);
            const totalLinea = (Number(item?.precio || 0) * cantidad).toFixed(2);
            const variante = item.variante || (item.item && item.item[0]) || '';
            return `${cantidad} x ${item.titulo}${variante ? `\n   Variante: ${variante}` : ''} - ${moneda} ${totalLinea}`;
        }).join('\n');

        const lineasDatos = [
            nombreCompleto.trim() ? `*Nombre:* ${nombreCompleto}` : '',
            fullReceiverPhone ? `*Teléfono:* ${fullReceiverPhone}` : '',
            deliveryOption === 'delivery' && direccion.trim() ? `*Dirección:* ${direccion}` : '',
            deliveryOption === 'delivery' && provincia ? `*Provincia:* ${provincia}` : '',
            deliveryOption === 'delivery' && municipio ? `*Municipio:* ${municipio}` : '',
            detalles.trim() ? `*Detalles:* ${detalles}` : ''
        ].filter(Boolean).join('\n');

        const entregaTexto = deliveryOption === 'delivery'
            ? '*Tipo de entrega:* Envío a domicilio'
            : '*Tipo de entrega:* Recogida en el local';

        const pagoTexto = paymentMethod === 'zelle' ? 'Zelle' : 'Efectivo';

        const encabezadoFactura = facturaNumero ? `*Factura #:* KY${facturaNumero}\n` : '';

        const mensaje = `https://mercadoky13.com/

🧾 *NUEVO PEDIDO*
${encabezadoFactura}
${lineasDatos}
${entregaTexto}

*Su Compra:*
${productosTexto}

*Forma de pago:* ${pagoTexto}
*Subtotal:* ${formatMoney(totalPrice)}
${deliveryOption === 'delivery' ? `*Envío:* ${formatMoney(shippingCost)}
` : ''}*TOTAL:* ${formatMoney(totalFinal)}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(mensaje)}`;

        if (isIOSDevice()) {
            setPendingWhatsappUrl(whatsappUrl);
            setPendingWhatsappMessage(mensaje);
            setShowWhatsappConfirm(true);
            setModalIsOpen2(false);
            return;
        }

        window.open(whatsappUrl, '_blank');
        clearCart();
        resetForm();
        setModalIsOpen2(false);
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const cartCount = cartItems.reduce((acc, item) => acc + (item.cantidad || 0), 0);

    return (
        <div>
            <ToastContainer />
            {showWhatsappConfirm && (
                <div className='whatsappConfirmOverlay'>
                    <div className='whatsappConfirmBox'>
                        <h3>Pedido registrado correctamente</h3>
                        <p>En iPhone debes tocar el botón para abrir WhatsApp y enviar los detalles del pedido.</p>
                        <button type='button' className='whatsappConfirmMain' onClick={() => {
                            const url = pendingWhatsappUrl;
                            clearCart();
                            resetForm();
                            setShowWhatsappConfirm(false);
                            setModalIsOpen(false);
                            setIsFocused(false);
                            openWhatsappNow(url);
                        }}>
                            Enviar pedido por WhatsApp
                        </button>
                        <button type='button' className='whatsappConfirmSecondary' onClick={() => {
                            clearCart();
                            resetForm();
                            setShowWhatsappConfirm(false);
                            setModalIsOpen(false);
                            setIsFocused(false);
                        }}>
                            Ya lo enviaré después
                        </button>
                    </div>
                </div>
            )}
            <button onClick={openModal} className='cartIconFixed'>
                {cartCount >= 1 && (
                    <span>{cartCount}</span>
                )}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <h4>Tu carrito</h4>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>

                {cartItems?.length === 0 ? (
                    <p className='nohay'>No hay productos</p>
                ) : (
                    <>
                        <div className="modal-content-cart">
                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>
                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart'>
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {(item?.item || []).map((sabor, i) => (
                                                        <span key={i}> {sabor}</span>
                                                    ))}
                                                </span>
                                                <strong>{moneda} {item?.precio}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className='upsellBox'>
                            <h4>Agrega esto a tu compra</h4>
                            <p>Clientes también agregan estos productos.</p>
                            <div className='upsellGrid'>
                                {upsellProducts.filter(p => !cartItems.some(c => c.idProducto === p.idProducto)).slice(0,3).map(p => (
                                    <button key={p.idProducto} type='button' onClick={()=>{
                                        const cart = safeJsonParse(safeGet('cart','[]'), []);
                                        cart.push({ idProducto:p.idProducto, item:[], cantidad:1 });
                                        safeSet('cart', JSON.stringify(cart));
                                        if (typeof window !== 'undefined') window.dispatchEvent(new Event('cartUpdated'));
                                    }}>
                                        <img src={p.imagen1 || p.imagen2 || p.imagen3 || p.imagen4} alt={p.titulo}/>
                                        <span>{p.titulo}</span>
                                        <b>{moneda} {p.precio}</b>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice.toFixed(2)}</h4>
                            <div className='deFLexBtns singleBtnWrap'>
                                <button className='btnContinuarPedido' onClick={openModal2}>
                                    Continuar con la compra
                                </button>
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} /></button>
                                <h4>Datos del que recibe</h4>
                            </div>

                            <div className="modal-send-form">
                                {showAccountChoice ? (
                                    <div className='accountCheckoutChoice'>
                                        <strong>¿Quieres usar los datos de tu cuenta?</strong>
                                        <p>Podemos rellenar automáticamente nombre, dirección y teléfono con tu perfil.</p>
                                        <div>
                                            <button type='button' className='btnContinuarPedido' onClick={useAccountData}>Sí, Usar mis datos (comprador)</button>
                                            <button type='button' className='btnSecondaryPedido' onClick={skipAccountData}>No, llenar manualmente</button>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                {(geoInfo && !geoInfo.isCuba && checkoutStep === 'buyer') ? (
                                    <div className='buyerCheckoutBox'>
                                        <strong>Datos de la persona que compra</strong>
                                        <p>Estos datos son solo para control interno. La factura y Telegram mostrarán los datos de quien recibe.</p>
                                        <input type="text" value={buyerNombre} onChange={(e)=>setBuyerNombre(e.target.value)} placeholder='Nombre del comprador' />
                                        <div className='phonePrefixGroup checkoutPhoneGroup'>
                                            <select value={buyerTelefonoPrefix} onChange={(e)=>setBuyerTelefonoPrefix(e.target.value)} aria-label='Prefijo comprador'>
                                                {COUNTRY_PREFIXES.map((p) => (
                                                    <option key={'buyer_' + p.code + p.dial} value={p.dial}>{p.flag} {p.name} {p.dial}</option>
                                                ))}
                                            </select>
                                            <input type="text" value={buyerTelefono} onChange={(e)=>setBuyerTelefono(e.target.value)} placeholder='Teléfono del comprador' />
                                        </div>
                                        <input type="email" value={buyerEmail} onChange={(e)=>setBuyerEmail(e.target.value)} placeholder='Correo del comprador' />
                                        <button type='button' className='btnContinuarPedido' onClick={()=>setCheckoutStep('receiver')}>Continuar con datos del receptor</button>
                                    </div>
                                ) : (
                                    <>
                                <h3 className='receiverCheckoutTitle'>Datos del que recibe</h3>
                                <input
                                    type="text"
                                    value={nombreCompleto}
                                    onChange={(e) => setNombreCompleto(e.target.value)}
                                    placeholder='Nombre completo'
                                />

                                <input
                                    type="text"
                                    value={direccion}
                                    onChange={(e) => setDireccion(e.target.value)}
                                    placeholder='Dirección'
                                />

                                <div className='phonePrefixGroup checkoutPhoneGroup'>
                                    <select value={telefonoPrefix} onChange={(e)=>setTelefonoPrefix(e.target.value)} aria-label='Prefijo receptor'>
                                        {COUNTRY_PREFIXES.map((p) => (
                                            <option key={'receiver_' + p.code + p.dial} value={p.dial}>{p.flag} {p.name} {p.dial}</option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                        placeholder='Teléfono'
                                    />
                                </div>

                                <div className='deliveryCalendarBox'>
                                    <strong>Calendario de entrega</strong>
                                    <div className='inlineDelivery'>
                                        <input type='date' value={deliveryDate} onChange={(e)=>setDeliveryDate(e.target.value)} />
                                        <input type='time' value={deliveryTime} onChange={(e)=>setDeliveryTime(e.target.value)} />
                                    </div>
                                </div>
                                <textarea
                                    placeholder="Detalles"
                                    value={detalles}
                                    onChange={(e) => setDetalles(e.target.value)}
                                />

                                <div className='deFLexRadio'>
                                    <label>Forma de pago</label>
                                    {(geoInfo && !geoInfo.isCuba) ? (
                                        <div>
                                            <input
                                                type="radio"
                                                id="zelle"
                                                name="paymentMethod"
                                                value="zelle"
                                                checked={paymentMethod === 'zelle'}
                                                onChange={() => setPaymentMethod('zelle')}
                                            />
                                            <label htmlFor="zelle">Zelle</label>
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                <input
                                                    type="radio"
                                                    id="efectivo"
                                                    name="paymentMethod"
                                                    value="efectivo"
                                                    checked={paymentMethod === 'efectivo'}
                                                    onChange={() => setPaymentMethod('efectivo')}
                                                />
                                                <label htmlFor="efectivo">Efectivo</label>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    id="zelle_cuba"
                                                    name="paymentMethod"
                                                    value="zelle"
                                                    checked={paymentMethod === 'zelle'}
                                                    onChange={() => setPaymentMethod('zelle')}
                                                />
                                                <label htmlFor="zelle_cuba">Zelle</label>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className='deFLexRadio'>
                                    <label>Tipo de entrega</label>
                                    <div>
                                        <input
                                            type="radio"
                                            id="delivery"
                                            name="deliveryOption"
                                            value="delivery"
                                            checked={deliveryOption === 'delivery'}
                                            onChange={() => setDeliveryOption('delivery')}
                                        />
                                        <label htmlFor="delivery">Envío a domicilio</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            id="pickup"
                                            name="deliveryOption"
                                            value="pickup"
                                            checked={deliveryOption === 'pickup'}
                                            onChange={() => setDeliveryOption('pickup')}
                                        />
                                        <label htmlFor="pickup">Recogida en el local</label>
                                    </div>
                                </div>

                                {deliveryOption === 'delivery' && (
                                    <>
                                        <select value={provincia} onChange={(e) => handleProvinciaChange(e.target.value)}>
                                            {provinciasDisponibles.map((prov) => (
                                                <option key={prov} value={prov}>{prov}</option>
                                            ))}
                                        </select>

                                        <select value={municipio} onChange={(e) => handleMunicipioChange(e.target.value)}>
                                            <option value="">Selecciona el municipio</option>
                                            {municipiosDisponibles.map((zone) => (
                                                <option key={zone.idZone || zone.municipio} value={zone.municipio}>{zone.municipio}</option>
                                            ))}
                                        </select>

                                        {municipio && (
                                            <div className='shippingBox'>
                                                Costo de envío: <strong>{moneda} {shippingCost.toFixed(2)}</strong>
                                            </div>
                                        )}
                                    </>
                                )}

                                <div className='resumeBox'>
                                    <span>Subtotal: <strong>{moneda} {totalPrice.toFixed(2)}</strong></span>
                                    {deliveryOption === 'delivery' && (
                                        <span>Envío: <strong>{moneda} {shippingCost.toFixed(2)}</strong></span>
                                    )}
                                    <span>Total: <strong>{moneda} {totalFinal.toFixed(2)}</strong></span>
                                </div>

                                <button onClick={handleWhatsappMessage} className='btnContinuarPedido'>
                                    Datos del que recibe
                                </button>
                                    </>
                                )}
                                    </>
                                )}
                            </div>
                        </Modal>
                    </>
                )}
            </Modal>
        </div>
    );
}
